<div ngForm="attendeeSettingsForm" class="form-horizontal">
	<vb-ui-horizontal-form-group>
		<label #uiLabel id="ewListingType">{{ 'Event_ListingType' | translate }}</label>

		<div uiControl>
			<div *ngIf="!isSidebar" aria-labelledby="ewListingType" vbUiRadioBtnGroup>
				<button type="button" class="btn btn-admin btn-white" [(ngModel)]="webcast.accessControl" (ngModelChange)="onAccessControlChanged()" name="accessControl" required *ngIf="publicListingVisible" [vbUiRadioBtn]="EventAccessControl.Public" [notThemed]="true" [activeClass]="'active'">{{ 'Event_Public' | translate }}</button>

				<button type="button" class="btn btn-admin btn-white" [(ngModel)]="webcast.accessControl" (ngModelChange)="onAccessControlChanged()" name="accessControl" required *ngIf="trustedPublicListingVisible" [vbUiRadioBtn]="EventAccessControl.TrustedPublic" [notThemed]="true" [activeClass]="'active'">{{ 'Event_TrustedPublic' | translate }}</button>

				<button type="button" class="btn btn-admin btn-white" #ewAccessControl="ngModel" [(ngModel)]="webcast.accessControl" (ngModelChange)="onAccessControlChanged()" name="accessControl" required [tooltip]="(displayPublicHoursInvalidWarning
							? 'Event_PublicWebcastLicenseNoViewingHours'
							: 'Event_PublicWebcastValidation') | translate
						" placement="bottom" triggers="" containerClass="access-control-tooltip" [isOpen]="displayPublicHoursInvalidWarning || ewAccessControl?.errors?.isProhibitPublicAccess" [prohibitPublicAccessValidator]="'Webcast'" [mediaFeatures]="features" [vbUiRadioBtn]="EventAccessControl.AllUsers" [notThemed]="true" [activeClass]="'active'">{{ 'Event_AllUsers' | translate }}</button>

				<button type="button" class="btn btn-admin btn-white" [(ngModel)]="webcast.accessControl" (ngModelChange)="onAccessControlChanged()" name="accessControl" required [vbUiRadioBtn]="EventAccessControl.Private" [notThemed]="true" [activeClass]="'active'">{{ 'Event_Private' | translate }}</button>
			</div>
			<span *ngIf="isSidebar" [ngSwitch]="webcast.accessControl">
				<span *ngSwitchCase="'Public'">{{ 'Event_Public' | translate }}</span>
				<span *ngSwitchCase="'AllUsers'">{{ 'Event_AllUsers' | translate }}</span>
				<span *ngSwitchCase="'Private'">{{ 'Event_Private' | translate }}</span>
				<span *ngSwitchCase="'TrustedPublic'">{{ 'Event_TrustedPublic' | translate }}</span>
			</span>
		</div>
	</vb-ui-horizontal-form-group>

	<div class="form-group row animate-if" *ngIf="webcast.accessControl === EventAccessControl.Private">
		<label class="control-label col-sm-3"></label>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-md-6 col-sm-9">
					<ng-template #accessEntityOptionRow let-item="item" let-insight="insight">
						<access-entity-option-row [item]="item" [insight]="insight"></access-entity-option-row>
					</ng-template>

					<ng-template #accessEntityAssignedRow let-item="item" let-insight="insight">
						<access-entity-assigned-row [item]="item" [insight]="insight"></access-entity-assigned-row>
					</ng-template>
					<insight *ngIf="accessControlInsightOptions" class="insight-listing" name="accessEntities" #uploaderUser="ngModel" [attr.aria-label]="'Event_Private_Attendees' | translate" [insightOptions]="accessControlInsightOptions" [(ngModel)]="webcast.accessEntities" [optionTemplate]="accessEntityOptionRow" [assignedTemplate]="accessEntityAssignedRow" [hidden]="hidden">
					</insight>
				</div>
			</div>
		</div>
	</div>
	<vb-ui-horizontal-form-group *ngIf="webcast.accessControl === EventAccessControl.Public">
		<label id="ewAttendeeJoinMethod" #uiLabel>{{ 'Event_AttendeeJoinMethod' | translate }}
			<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_AttendeeJoinMethod_Help' | translate">
			</vb-ui-tooltip>
		</label>

		<div uiControl>
			@if(!isSidebar) {
				<div class="d-flex justify-content-between">
					<div aria-labelledby="ewAttendeeJoinMethod" vbUiRadioBtnGroup>
						<button type="button" class="btn btn-admin btn-white" [(ngModel)]="webcast.attendeeJoinMethod" name="attendeeJoinMethod" [vbUiRadioBtn]="AttendeeJoinMethod.Anonymous" (ngModelChange)="onAttendeeJoinMethodChange()" [notThemed]="true" [activeClass]="'active'">{{ 'Anonymous' | translate }}</button>

						<button type="button" class="btn btn-admin btn-white" [(ngModel)]="webcast.attendeeJoinMethod" name="attendeeJoinMethod" [vbUiRadioBtn]="AttendeeJoinMethod.Registration" [notThemed]="true" [activeClass]="'active'">{{ 'Registration' | translate }}</button>
					</div>
					@if(webcast.accessControl === EventAccessControl.Public && webcast.attendeeJoinMethod === 'Registration') {
						<button type="button" class="theme-accent-link link-button" (click)="previewGuestLogin()">
							{{ 'Event_PreviewGuestRegistration' | translate }}
						</button>
					}
				</div>
			}
			@else {
				<span>{{
					webcast.attendeeJoinMethod === 'Registration' || webcast.attendeeJoinMethod === 'Anonymous'
						? (webcast.attendeeJoinMethod | translate)
						: ''
				}}</span>
			}
		</div>
	</vb-ui-horizontal-form-group>

	<vb-ui-horizontal-form-group class="animate-if" *ngIf="webcast.accessControl === EventAccessControl.Public">
		<label #uiLabel for="accessCode">{{ 'Password' | translate }}</label>
		<div uiControl>
			<input class="form-control" id="accessCode" type="text" name="accessCode" #accessCode="ngModel" autocomplete="new-password" [attr.data-lpignore]="true" [(ngModel)]="webcast.password" pattern="^\S+$">
			<span class="help-block" [hidden]="webcast.password?.length !== 0">{{ 'Event_PasswordNotRequired' | translate }}</span>
			<span class="help-block" [hidden]="!accessCode?.errors?.pattern">{{ 'Event_PasswordSpaceCharNotAllowed' | translate }}</span>
		</div>
	</vb-ui-horizontal-form-group>

	<div class="form-group row" *ngIf="webcast.accessControl === EventAccessControl.Public
			&& webcast.attendeeJoinMethod !== AttendeeJoinMethod.Anonymous" [hidden]="!registrationFieldsReady">
		<label class="control-label col-sm-3">
			{{ 'Admin_SystemSettings_CustomFields_WebcastRegistrationFields' | translate }}
		</label>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-sm-6">
					<div class="clearfix">
						<p class="help-block mt-0 mb-2">{{ 'Event_Edit_RegistrationFieldHelpText' | translate }}</p>
					</div>
					<select-registration-fields name="ewRegistrationFields" [(ngModel)]="webcast.registrationFields" (onReady)="registrationFieldsReady = true">
					</select-registration-fields>
				</div>
			</div>
		</div>
	</div>
	<div class="form-group row" *ngIf="webcast.accessControl === EventAccessControl.Public
		&& webcast.attendeeJoinMethod !== AttendeeJoinMethod.Anonymous && features.enableWebcastCustomConsent">
		<label class="control-label col-sm-3">
			{{ 'Admin_SystemSettings_CustomFields_CustomizeConsentVerbiage' | translate }}
			<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_Registration_EnableCustomizeConsentVerbiageDisclaimer' | translate">
			</vb-ui-tooltip>
		</label>
		<div class="col-sm-9">
			<div class="row">
				<div class="col-sm-6">
					<div vbUiRadioBtnGroup [attr.aria-label]="'Event_Registration_EnableCustomizeConsentVerbiageDisclaimer_Title' | translate">
						<button type="button" class="btn btn-admin btn-white" [(ngModel)]="webcast.isCustomConsentEnabled" name="isCustomConsentEnabled" [vbUiRadioBtn]="true" (ngModelChange)="onCustomizeConsentVerbiageChanged()" [notThemed]="true" [activeClass]="'active'">
							{{ 'Enabled' | translate }}
						</button>
						<button type="button" class="btn btn-admin btn-white" [(ngModel)]="webcast.isCustomConsentEnabled" name="isCustomConsentEnabled" [vbUiRadioBtn]="false" (ngModelChange)="onCustomizeConsentVerbiageChanged()" [notThemed]="true" [activeClass]="'active'">
							{{ 'Disabled' | translate }}
						</button>
					</div>
					<div *ngIf="webcast.isCustomConsentEnabled">
						<textarea class="form-control margin-top-10" id="ewConsentVerbiage" vbUiTextArea uiControl [vbMaxLength]="500" required rows="2" name="consentVerbiage" #ewConsentVerbiage="ngModel" [(ngModel)]="webcast.consentVerbiage" trim="blur">
						</textarea>
						<div *ngIf="ewConsentVerbiage.invalid" role="alert" vbUiErrorMessage uiValidation>
							@if (ewConsentVerbiage.errors.required) {
								{{ 'Event_Registration_ConsentVerbiageValidation' | translate }}
							} @else if (ewConsentVerbiage.errors.vbMaxLength) {
								{{ 'MaximumAllowedCharacters' | translate: {'0': 500} }}
							}
						</div>
					</div>
					<p class="help-block" [hidden]="webcast.isCustomConsentEnabled">
						{{ 'Event_Registration_GdprConsent' | translate }}
					</p>
					<div [ngClass]="styles.customConsentUpdateColumn">
						<div *ngFor="let update of webcast.customConsentDetails.customConsentVerbiageUpdates">
								{{ 'Event_Registration_ConsentVerbiageUpdates' | translate: {'0': update.username, '1': update.name, '2': update.submissionTimestamp | vbDateTimeMedium} }}
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>

	<div *ngIf="!features.onPrem &&
		!isSidebar &&
		webcast.accessControl === EventAccessControl.Public &&
		webcast.attendeeJoinMethod !== AttendeeJoinMethod.Anonymous">
		<div class="form-group row">
			<label class="control-label col-sm-3" for="ewEmailRegistrant">
				{{ 'Event_AllowPreRegistration_Email' | translate }}
				<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_AllowPreRegistration_Email_Help' | translate">
				</vb-ui-tooltip>
			</label>
			<div class="col-sm-9">
				<div class="row">
					<div class="col-sm-6">
						<input type="checkbox" id="ewEmailRegistrant" name="ewEmailRegistrant" [(ngModel)]="webcast.emailToPreRegistrants">
					</div>
				</div>
			</div>
		</div>
	</div>

	<vb-ui-horizontal-form-group>
		<label #uiLabel for="estimatedAttendees">{{ 'Event_EstimatedAttendees' | translate }}</label>
		<input uiControl class="form-control" id="estimatedAttendees" name="estimatedAttendees" type="text" [(ngModel)]="webcast.estimatedAttendees" #estimatedAttendees="ngModel" vbInteger [vbMin]="0" [vbMax]="1000000"/>

		<div *ngIf="estimatedAttendees.invalid" role="alert" vbUiErrorMessage uiValidation>
			@if (estimatedAttendees.errors.vbInteger) {
				{{ 'MustContainNumbers' | translate }}
			} @else if (estimatedAttendees.errors.vbMin) {
				{{ 'MustContainNumberRange' | translate : { '0': 0, '1': 1000000 } }}
			} @else if (estimatedAttendees.errors.vbMax) {
				{{ 'MustContainNumberRange' | translate : { '0': 0, '1': 1000000 } }}
			}
		</div>
	</vb-ui-horizontal-form-group>

	<div *ngIf="features.enableUnlisted">
		<vb-ui-horizontal-form-group>
			<label for="ewUnlisted" #uiLabel>{{ 'Event_Unlisted' | translate }}</label>
			<div uiControl>
				<input type="checkbox" id="ewUnlisted" name="ewUnlisted" [(ngModel)]="webcast.unlisted">
				<div [ngClass]="styles.checkLabel">
					{{ 'Event_Unlisted_Message' | translate }}
				</div>
			</div>
		</vb-ui-horizontal-form-group>
	</div>
	<div *ngIf="features.viewerIdSettings?.viewerIdPolicy === ViewerIdPolicy.ALLOW">
		<vb-ui-horizontal-form-group>
			<label for="ewViewerIdEnabled" #uiLabel>{{ 'Viewer_Id_Enable' | translate }}
			<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'Event_ViewerIdWaterMark_HelperText' | translate">
			</vb-ui-tooltip>
			</label>
			<div uiControl>
				<input type="checkbox" id="ewViewerIdEnabled" name="ewViewerIdEnabled" [(ngModel)]="webcast.viewerIdEnabled">
				<div [ngClass]="styles.checkLabel">
					{{ 'Event_Edit_ViewerId_Label' | translate }}
				</div>
			</div>
		</vb-ui-horizontal-form-group>
		<div *ngIf="webcast.viewerIdEnabled">
			<vb-ui-horizontal-form-group>
				<label for="ewViewerIdWatermarkText" #uiLabel>
					{{ 'Viewer_Id_Custom_Text' | translate }}
				</label>
				<div uiControl>
					<input class="form-control" id="ewViewerIdWatermarkText" name="ewViewerIdWatermarkText" type="text" #ewViewerIdWatermarkText="ngModel" [(ngModel)]="webcast.viewerIdWatermarkText" [vbMaxLength]="48"/>
				</div>
				<div *ngIf="ewViewerIdWatermarkText.invalid" role="alert" vbUiErrorMessage uiValidation>
					@if (ewViewerIdWatermarkText.errors.vbMaxLength) {
						{{ 'MaximumAllowedCharacters' | translate : { '0': 48} }}
					}
				</div>
			</vb-ui-horizontal-form-group>
		</div>
	</div>
	@if (!isSidebar && features.enableEmbeds && features.enableWebcastDomainAllowlist) {
		<ng-container>
			<vb-ui-horizontal-form-group>
				<span #uiLabel [ngClass]="styles.formLabel">
					{{ 'EmbeddingDomainRestriction' | translate }}
					<vb-ui-tooltip [iconName]="'circle_question_mark'" [placement]="'right'" [text]="'EmbeddingDomainRestriction_Webcast_HelperText' | translate">
					</vb-ui-tooltip>
				</span>
				<div uiControl [ngClass]="styles.valueColor">
					{{ 'Enabled' | translate }}
				</div>
			</vb-ui-horizontal-form-group>
			@if (features.enableAllowAdditionalDomains) {
				<vb-ui-horizontal-form-group>
					<label for="additionalEmbedDomains" #uiLabel>
						<span>{{ 'EmbedAdditionalDomains' | translate }}</span>
					</label>
					<div uiControl>
						<div class="margin-bottom-5">
							<span>{{ 'EmbedAdditionalDomains_Webcast_HelperText' | translate }}</span>
						</div>
						<textarea vbUiTextArea vbUiSplitLinesInput id="additionalEmbedDomains" name="additionalEmbedDomains" [(ngModel)]="webcast.additionalEmbedDomains" rows="4">
						</textarea>
					</div>
				</vb-ui-horizontal-form-group>

			}
		</ng-container>
	}
</div>
